import cookie from "js-cookie";

/**
 * Usuwa ciasteczko ze wszystkimi możliwymi kombinacjami opcji
 * @param {string} cookieName - nazwa ciasteczka do usunięcia
 */
const removeCookie = (cookieName, domain) => {
	if (!cookieName) {
		return;
	}

	try {
		// Usuwanie z różnymi kombinacjami opcji domain, path i secure
		const removalOptions = [
			{
				path: "/",
				domain: `${domain}`,
			},
			{
				path: "/",
				domain: `${domain}`,
				secure: true,
			},
			{
				path: "/",
				domain: `${domain}`,
				secure: false,
			},
			{
				path: "/",
				secure: false,
			},
			{
				path: "/",
				secure: true,
			},
			{
				path: "/",
			},
		];

		// Próba usunięcia ciasteczka z każdą z opcji
		removalOptions.forEach((options) => {
			cookie.remove(cookieName, options);
		});
	} catch (err) {
		console.warn("removeCookie error", err);
	}
};

export default removeCookie;
